import React from 'react';
import { Link } from 'react-router-dom';
import './ApartmentCard.css';

function formatPrice(rub) {
  return new Intl.NumberFormat('ru-RU').format(rub) + ' ₽';
}

function resolveUrl(url) {
  if (!url) return null;
  return url;
}

export default function ApartmentCard({ apartment }) {
  const photo = resolveUrl(apartment.photos?.[0]);
  const photoCount = apartment.photos?.length || 0;

  return (
    <Link to={`/apartment/${apartment.id}`} className="apt-card card" style={{ textDecoration: 'none', color: 'inherit' }}>
      <div className="apt-card-img-wrap">
        {photo ? (
          <img src={photo} alt={apartment.name} className="apt-card-img" />
        ) : (
          <div className="apt-card-no-photo">📷 Нет фото</div>
        )}
        {photoCount > 1 && (
          <span className="apt-card-photo-count">📷 {photoCount}</span>
        )}
        <div className="apt-card-price-badge">
          {formatPrice(apartment.price_per_night_rub)} <span className="price-badge-unit">/ ночь</span>
        </div>
      </div>
      <div className="apt-card-body">
        <h2 className="apt-card-name">{apartment.name}</h2>
        <p className="apt-card-address">📍 {apartment.address}</p>

        {apartment.description && (
          <p className="apt-card-desc">{apartment.description}</p>
        )}

        <div className="apt-card-meta">
          <span>👥 до {apartment.max_guests} гостей</span>
          {apartment.amenities?.length > 0 && (
            <span>{apartment.amenities.slice(0, 2).join(' · ')}</span>
          )}
        </div>
      </div>
    </Link>
  );
}